// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getTeacherChangeReasonById } from 'app/constants/enums/TeacherChangeReason/main';

/* eslint-disable max-len */
export const CANCELLED_BY_STAFF = getTeacherChangeReasonById('cancelledByStaff');
export const CANCELLED_BY_TEACHER = getTeacherChangeReasonById('cancelledByTeacher');
export const TEACHER_ABSENT = getTeacherChangeReasonById('teacherAbsent');
/* eslint-enable max-len */
